export const blockIconsActivitiesSportsKabaddiNew = (
	<span className='material-symbols-outlined'>sports_kabaddi</span>
);
